export default __webpack_public_path__ + "static/media/cp-themeB.88f6352c.png";